/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import BaseComponent from './../../../panther/components/base/BaseComponent';

import MicrositeIntro from './MicrositeIntro/MicrositeIntro';
import MicrositeFooter from './MicrositeFooter/MicrositeFooter';
import MicrositeSection from './MicrositeSection/MicrositeSection';
import MicrositeSectionBasic from './MicrositeSection/MicrositeSectionBasic/MicrositeSectionBasic';
import MicrositeSectionContacts from './MicrositeSection/MicrositeSectionContacts/MicrositeSectionContacts';
import MicrositeSectionPanels from './MicrositeSection/MicrositeSectionPanels/MicrositeSectionPanels';
import Service1 from '../Pucs/Service1';
import Service2 from '../Pucs/Service2';
import Service3 from '../Pucs/Service3';

import styles from './MicrositePage.css';
import Footer from "../Pucs/Footer";

class MicrositePage extends BaseComponent {

    render() {
        let content = this.renderSections();

        return (
            <div id="microsite-page">
                <MicrositeIntro
                    title={this.props.intro.title}
                    text={this.props.intro.text}
                    mapButton={this.props.intro.mapButton}
                />
                {content}
                <Footer/>
            </div>
        );
    }

    renderSections(){
        let content  = [];
        let sections = this.props.sections;

        sections.map(section => {
            content.push(this.getSectionByType(section));
        });

        return content;
    }

    getSectionByType(section){
        let content;

        switch (section.type) {
            case "basic":
                content = (
                    <MicrositeSectionBasic
                        key={section.data.id}
                        id={section.data.id}
                        name={section.data.title}
                        colorTheme={section.colorTheme}
                        introduction={section.data.introduction}
                        textCentered
                    />
                );
                break;
            case "panels":
                content = (
                    <MicrositeSectionPanels
                        key={section.data.id}
                        id={section.data.id}
                        name={section.data.title}
                        colorTheme={section.colorTheme}
                        introduction={section.data.introduction}
                        maxItemsInRow={section.maxItemsInRow}
                        panels={section.data.panels}
                        textCentered
                    />
                );
                break;
            case "panels-highlighted":
                content = (
                    <MicrositeSectionPanels
                        key={section.data.id}
                        id={section.data.id}
                        name={section.data.title}
                        colorTheme={section.colorTheme}
                        introduction={section.data.introduction}
                        maxItemsInRow={section.maxItemsInRow}
                        panels={section.data.panels}
                        panelsHighlighted
                        textCentered
                    />
                );
                break;
            case "contacts":
                content = (
                    <MicrositeSectionContacts
                        key={section.data.id}
                        id={section.data.id}
                        name={section.data.title}
                        colorTheme={section.colorTheme}
                        maxItemsInRow={section.maxItemsInRow}
                        contacts={section.data.contacts}
                        textCentered
                    />
                );
                break;
            case "service-1":
                content = (
                    <Service1
                        key={section.data.id}
                        id={section.data.id}
                        name={section.data.title}
                        textCentered
                    />
                );
                break;
            case "service-2":
                content = (
                    <Service2
                        key={section.data.id}
                        id={section.data.id}
                        name={section.data.title}
                        textCentered
                    />
                );
                break;
            case "service-3":
                content = (
                    <Service3
                        key={section.data.id}
                        id={section.data.id}
                        name={section.data.title}
                        textCentered
                    />
                );
                break;
            default:
                content = (<MicrositeSection
                    key={section.data.id}
                    id={section.data.id}
                    name={section.data.title}
                    colorTheme={section.colorTheme}
                    textCentered
                />)
        }

        return content;
    }
}

MicrositePage.propTypes = {
    intro: PropTypes.object,
    sections: PropTypes.array,
    footer: PropTypes.object,
};

export default MicrositePage;